import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      width: "32",
      height: "32",
      fill: "currentColor",
      "fill-opacity": ".18",
      rx: "3"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16 6C10.48 6 6 10.48 6 16s4.48 10 10 10 10-4.48 10-10S21.52 6 16 6m4.03 8.2-4.67 4.66a.7.7 0 0 1-.53.22c-.19 0-.38-.07-.53-.22l-2.33-2.33a.754.754 0 0 1 0-1.06c.29-.29.77-.29 1.06 0l1.8 1.8 4.14-4.13c.29-.3.77-.3 1.06 0 .29.29.29.76 0 1.06"
    }, null, -1)
  ])))
}
export default { render: render }